/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { HTTPValidationError, ProfessionalProfileResponse } from './platformapi.schemas';

import getProfessionalByIdMutator from '../custom-axios-instance';

/**
 * @summary Get Professional By Id
 */
export const getProfessionalById = (proUserId: number, signal?: AbortSignal) => {
  return getProfessionalByIdMutator<ProfessionalProfileResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/directory_professionals/${proUserId}`,
    method: 'GET',
    signal,
  });
};

export const getGetProfessionalByIdQueryKey = (proUserId: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/directory_professionals/${proUserId}`] as const;
};

export const getGetProfessionalByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfessionalById>>,
  TError = void | HTTPValidationError,
>(
  proUserId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalById>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfessionalByIdQueryKey(proUserId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfessionalById>>> = ({ signal }) =>
    getProfessionalById(proUserId, signal);

  return { queryKey, queryFn, enabled: !!proUserId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfessionalById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProfessionalByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfessionalById>>
>;
export type GetProfessionalByIdQueryError = void | HTTPValidationError;

export function useGetProfessionalById<
  TData = Awaited<ReturnType<typeof getProfessionalById>>,
  TError = void | HTTPValidationError,
>(
  proUserId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfessionalById>>,
          TError,
          Awaited<ReturnType<typeof getProfessionalById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProfessionalById<
  TData = Awaited<ReturnType<typeof getProfessionalById>>,
  TError = void | HTTPValidationError,
>(
  proUserId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfessionalById>>,
          TError,
          Awaited<ReturnType<typeof getProfessionalById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProfessionalById<
  TData = Awaited<ReturnType<typeof getProfessionalById>>,
  TError = void | HTTPValidationError,
>(
  proUserId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalById>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Professional By Id
 */

export function useGetProfessionalById<
  TData = Awaited<ReturnType<typeof getProfessionalById>>,
  TError = void | HTTPValidationError,
>(
  proUserId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalById>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProfessionalByIdQueryOptions(proUserId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
